import React, { useEffect, useState } from "react";
import { MainLayoutAdmin } from "../../../layout/MainLayoutAdmin";
import { useParams, useNavigate, Link } from "react-router-dom";
import {HOST} from '../../../config';

function ExamQuestList() {
  const [listQuestion, setListQuestion] = useState([]);
  const [deleteId, setDeleteId] = useState();
  const { examId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/admin/login");
    }
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${HOST}/exam/admin/${examId}/question`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const data = JSON.parse(result);
        setListQuestion(data);
      })
      .catch((error) => {
        alert("Có lỗi xảy ra");
        console.log("error", error);
      });
  }, [deleteId]);

  function deleteQuestion(questionId) {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/admin/login");
    }
    const myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${HOST}/exam/${examId}/question/${questionId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        alert('Xoá thành công')
        setDeleteId(examId);
        console.log(result)
      })
      .catch((error) => console.log("error", error));
  }

  return (
    <MainLayoutAdmin>
      <Link
        to={'/admin/exam/' + examId + '/quest'}
        className="text-white bg-cyan-600 hover:bg-cyan-700 focus:ring-4 focus:ring-cyan-200 font-medium rounded-lg text-sm inline-flex items-center px-3 py-2 m-2 text-center"
      >
        Tạo câu hỏi
      </Link>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="align-middle inline-block min-w-full">
            <div className="shadow overflow-hidden">
              <table className="table-fixed min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th
                      scope="col"
                      className="p-4 text-left text-xs font-medium text-gray-500"
                    >
                      Câu hỏi
                    </th>
                    <th scope="col" className="p-4"></th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {listQuestion.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-100">
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        Câu hỏi {item.name}
                      </td>
                      <td className="p-4 whitespace-nowrap space-x-2">
                        <Link
                          to={'/admin/exam/' + examId + '/quest/' + item.id}
                          type="button"
                          data-modal-toggle="product-modal"
                          className="text-white bg-cyan-600 hover:bg-cyan-700 focus:ring-4 focus:ring-cyan-200 font-medium rounded-lg text-sm inline-flex items-center px-3 py-2 text-center"
                        >
                          Sửa câu hỏi
                        </Link>
                        <button
                          onClick={() => deleteQuestion(item.id)}
                          type="button"
                          className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm inline-flex items-center px-3 py-2 text-center"
                        >
                          Xoá
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </MainLayoutAdmin>
  );
}

export default ExamQuestList;
